import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Notification } from "react-admin";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import history from "../common/history";
import TranslatedText from "./TranslatedText";
import defaultTheme from "../common/themes";
import tccStyles from "../common/styles";
import LoginForm from "./MyLoginForm";
import { isStaging } from "../common/utilities";

const styles = theme => ({
    main: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        height: "1px",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundSize: "cover"
    },
    card: {
        minWidth: 400,
        marginTop: "2em",
        minHeight: isStaging() ? 372 : 372
    },
    avatar: {
        margin: "1em",
        display: "flex",
        justifyContent: "center"
    },
    icon: {
        backgroundColor: theme.palette.secondary[500]
    },
    link: {
        width: "90%",
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 20,
        color: "black",
        background: "white",
        paddingButtom: 30
    },
    infoline: {
        marginTop: 6
    },
    infolineIcon: { color: tccStyles.login.infoline.iconColor },
    infolineIconBox: { position: "relative", top: 6 },
    appTitle: { textAlign: "center", marginTop: 40 },
    appLogo: { paddingTop: 70, textAlign: "center" },
    appHeader: {
        height: "6px",
        width: "100%",
        top: 0,
        position: "fixed",
        zIndex: 1000
    }
});

const loginFormStyles = theme => ({
    button: {
        backgroundColor: tccStyles.login.button.backgroundColor
    }
});

const MyLoginForm = withStyles(loginFormStyles)(LoginForm);

const sanitizeRestProps = ({
    classes,
    className,
    location,
    title,
    array,
    theme,
    staticContext,
    ...rest
}) => rest;

const Login = ({ classes, className, loginForm, ...rest }) => (
    <div
        className={classnames(classes.main, className)}
        {...sanitizeRestProps(rest)}
    >
        <img
            src="/static/images/sfondo_header.png"
            alt="sfondo"
            className={classes.appHeader}
        />
        <div className={classes.appLogo}>
            <img src="/static/images/logo_ts.png" alt="Logo" width="100px" />
        </div>
        <span className={classes.appTitle}>
            <Typography component="h2" variant="display1">
                TeamSystem Cloud Console
            </Typography>
        </span>
        <Card className={classes.card}>
            <div className={classes.avatar}>
                <Avatar className={classes.icon}>
                    <LockIcon />
                </Avatar>
            </div>
            <MyLoginForm />
            <Button
                type="submit"
                variant="outlined"
                onClick={() => {
                    history.push(`/reset_password`);
                }}
                disabled={false}
                className={classes.link}
            >
                <TranslatedText resource_name="ra.auth.pwd_forgot" />
            </Button>
        </Card>
        <span className={classes.infoline}>
            <span className={classes.infolineIconBox}>
                <InfoIcon className={classes.infolineIcon} />
            </span>
            <span>
                <TranslatedText resource_name="insert_user_credentials" />
            </span>
        </span>

        <Notification />
    </div>
);

Login.propTypes = {
    className: PropTypes.string,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    input: PropTypes.object,
    meta: PropTypes.object,
    previousRoute: PropTypes.string
};

Login.defaultProps = {
    theme: defaultTheme
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/MyLoginPage.js